export const rhfNumberValidation = (value, input) => {
  return Number(value) > Number(input === null || input === void 0 ? void 0 : input.max) || Number(value) < Number(input === null || input === void 0 ? void 0 : input.min);
};
export const numberValidation = (value, max, min) => {
  if (value === undefined || value === null) {
    return true;
  }
  if (isNaN(value)) {
    return false;
  }
  const numMin = min !== null && min !== void 0 ? min : Number.NEGATIVE_INFINITY;
  const numMax = max !== null && max !== void 0 ? max : Number.POSITIVE_INFINITY;
  const valueStr = value.toString();
  const isPartialValid = value >= numMin && value <= numMax;
  const isCompleteValid = parseFloat(valueStr + '0') >= numMin && parseFloat(valueStr + '9') <= numMax || valueStr === '1' && numMax >= 10;
  return isPartialValid || isCompleteValid;
};

//Función que verifica si el value es valido respecto al min y max del number input para dar error al hacer onBlur
export const isValidOnBlur = (value, min, max, focused) => {
  if (value === undefined || value === null) return true;
  if (!focused && (min !== undefined && value < min || max !== undefined && value > max)) return false;
  return true;
};